import { TranslationKey } from './../../../types/translation/TranslationKey';
import React, { useContext } from 'react';
import { t } from '../../../types/translation/Translator';
import Pane from '../../../VentoryUI/components/common/Pane';
import { Route, Routes } from 'react-router-dom';
import AssetOverviewPane from './Panes/AssetOverviewPane';
import AssetOverviewHistoryPane from './Panes/AssetOverviewHistoryPane';
import { AssetTransactionContext } from '../../../context/AssetTransactionContext';
import { CompanyContext } from '../../../context/CompanyContext';
import AssetPendingPane from './Panes/AssetPendingPane';
import {
  AssetTransaction,
  AssetTransactionParentType,
  AssetTransactionStatus,
  AssetTransactionType,
} from '../../../types/asset_transaction/assetTransaction';
import { Company } from '../../../types/company';
import Provider from '../../../providers/common/Provider';
import AssetInfoScreen from './AssetInfoScreen';
import AssetSettingsScreen from './AssetSettingsScreen';
import UserAssetScreen from './UserAssetScreen';

const tabs = (transactions: Map<string, AssetTransaction>, company: Company) => {
  const hasOpen = new Set(
    [...transactions.values()]
      .filter(
        transaction =>
          transaction.parentType === AssetTransactionParentType.returnAsset &&
          transaction.type === AssetTransactionType.outbound &&
          transaction.status === AssetTransactionStatus.pending,
      )
      .map(transaction => transaction.parentId),
  );

  const pending = [...transactions.values()].filter(
    transaction =>
      transaction.status === AssetTransactionStatus.pending &&
      !transaction.location &&
      !hasOpen.has(transaction.parentId),
  ).length;
  return [
    {
      text: t(TranslationKey.asset).plural.label,
      path: 'info',
      key: 'info',
    },
    {
      text: (
        <span className='flex items-center gap-2'>
          <p>{t(TranslationKey.pending).singular.label}</p>
          {pending ? (
            <span className='flex size-4 items-center justify-center rounded-full bg-primary text-xs text-on-primary'>
              {pending > 9 ? '9+' : pending}
            </span>
          ) : null}
        </span>
      ),
      path: 'pending',
      key: 'pending',
      disabled: !pending,
    },
    {
      text: t(TranslationKey.history).plural.label,
      path: 'history',
      key: 'history',
    },
  ];
};

export default function AssetScreen() {
  return (
    <Provider
      asset
      assetExportConfiguration
      tableSettings
      assetTransaction
      customField
      productMasterData
      user
      tag
      tagRelation
    >
      <Element />
    </Provider>
  );
}

function Element() {
  const { assetTransactions } = useContext(AssetTransactionContext);
  const { currentCompany } = useContext(CompanyContext);

  return (
    <>
      <Routes>
        <Route path='settings/*' element={<AssetSettingsScreen />} />
        <Route path='detail/:id/*' element={<AssetInfoScreen />} />
        <Route path='personal/*' element={<UserAssetScreen />} />
        <Route
          path='*'
          element={
            <Pane tabs={tabs(assetTransactions, currentCompany)}>
              <Routes>
                <Route path='info' element={<AssetOverviewPane />} />
                <Route path='pending' element={<AssetPendingPane />} />
                <Route path='history' element={<AssetOverviewHistoryPane />} />
              </Routes>
            </Pane>
          }
        />
      </Routes>
    </>
  );
}
